import * as React from 'react';
import { OnlyForFairPlayersWrapper } from '../OnlyForFairPlayersWrapper';

export const OnlyForFairPlayersDeclineError = () => {
  return (
    <OnlyForFairPlayersWrapper>
      Запрос на&nbsp;участие в&nbsp;программе «Работаю честно» не&nbsp;может быть зарегистрирован повторно.
      <br />
      Дождитесь результатов рассмотрения текущего запроса.
    </OnlyForFairPlayersWrapper>
  );
};
